import cx from 'classnames';

import styles from './Tooltip.scss';

import type { PropsWithChildren } from 'react';

type TooltipBodyProps = PropsWithChildren<{
  withMouseClick?: boolean;
}>;

const TooltipBody = ({ children, withMouseClick }: TooltipBodyProps) => (
  <div
    className={cx(styles.body, {
      [styles.withMouseClick]: withMouseClick,
    })}
  >
    {children}
  </div>
);

export default TooltipBody;
